import { Injectable, signal } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import {
  BoardGate,
  GetAllBoardMetadataAndPersonalBoardResponse,
} from '../../../../../backend/src/core/board/board.gate';
import { ResourceName } from '../../../../../backend/src/core/resource-name';
import { LambdaService } from '../../shared/core/lambda.service';

@Injectable({ providedIn: 'root' })
export class InitAllBoardListService {
  private resourceName = ResourceName.board;

  private cachedData$?: Observable<GetAllBoardMetadataAndPersonalBoardResponse>;

  isMaintainanceMode = signal<boolean>(false);
  maintainanceText = signal<string>('');

  constructor(private lambdaService: LambdaService) {}

  getAllBoardMetadataAndPersonalBoardAndChangeDefaultWorkspace$(
    workspaceId?: string
  ): Observable<GetAllBoardMetadataAndPersonalBoardResponse> {
    if (!this.cachedData$) {
      this.cachedData$ = this.lambdaService
        .run$(this.resourceName, BoardGate.actions.getAllBoardMetadataAndPersonalBoard, { workspaceId })
        .pipe(shareReplay(1));
    }
    return this.cachedData$;
  }
}
